import React from 'react';
import blank from '../../../assets/images/blank.png';

const Home = () => (
  <img src={blank} style={{ display: 'block', margin: 'auto', paddingTop: '40px', paddingBottom: '40px' }} />
);

export default Home;



// WEBPACK FOOTER //
// ./src/app/views/Home/Home.js